import { useNavigate } from "react-router-dom";
import { Props } from "../types";
import { track } from "@amplitude/analytics-browser";
type RemoveProps = Pick<Props, "setBooks" | "setLastBooksRead"> & {
  id: string;
};
export const Remove = (props: RemoveProps) => {
  const { setBooks, setLastBooksRead, id } = props;
  const navigate = useNavigate();
  const remove = () => {
    track("tracker: remove book", {
      id,
    });
    setBooks((bs) => {
      const newRecord = { ...bs };
      delete newRecord[id];
      return newRecord;
    });
    setLastBooksRead(id, true);
    setTimeout(() => navigate("/home"));
  };
  return (
    <button
      style={{
        // position: "absolute",
        // top: "5px",
        // right: "5px",
        margin: "2rem 0",
        backgroundColor: "#ff3a30",
        borderRadius: "5px",
        fontSize: "1rem",
        color: "white",
      }}
      onClick={remove}
    >
      Delete book
    </button>
  );
};
